<template>
  <div>
    <p class="mb-3">
      Selecione até <strong>5 arquivos PDF</strong> de apólices para extração automática via IA.
      Os dados serão extraídos e apresentados para sua revisão antes de serem salvos.
    </p>

    <b-form-file
      v-model="localFiles"
      multiple
      accept=".pdf"
      browse-text="Selecionar arquivos"
      placeholder="Escolha até 5 arquivos PDF ou arraste para este campo..."
      drop-placeholder="Solte os arquivos aqui..."
      :state="fileState"
      @change="onFilesChange"
    ></b-form-file>

    <div v-if="localFiles && localFiles.length" class="mt-2">
      <small class="text-muted">{{ localFiles.length }} arquivo(s) selecionado(s)</small>
      <ul class="list-unstyled mt-1 mb-0">
        <li v-for="(f, i) in localFiles" :key="i" class="small">
          <i class="fas fa-file-pdf text-danger mr-1"></i>{{ f.name }}
        </li>
      </ul>
    </div>

    <div v-if="tooManyFiles" class="alert-custom alert-danger-custom mt-2">
      Selecione no máximo 5 arquivos PDF por vez.
    </div>
  </div>
</template>

<script>
const MAX_FILES = 5;

export default {
  name: 'UploadPdfStep',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localFiles: this.value || [],
    };
  },
  computed: {
    tooManyFiles() {
      return this.localFiles && this.localFiles.length > MAX_FILES;
    },
    fileState() {
      if (!this.localFiles || !this.localFiles.length) return null;
      return !this.tooManyFiles;
    },
  },
  methods: {
    onFilesChange(event) {
      const files = Array.from(event.target.files || []);
      this.localFiles = files;
      this.$emit('input', files);
    },
  },
  watch: {
    value(val) {
      this.localFiles = val;
    },
  },
};
</script>
